import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import Promises from "@/components/Promises";
import ConversionBlock from "@/components/ConversionBlock";
import References from "@/components/References";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollRail from "@/components/ScrollRail";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
    }
  }, [location]);

  return (
    <div data-testid="home-page" style={{ background: "var(--ink)" }}>
      <Nav />
      <ScrollRail />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <Promises />
        <References />
        <About />
        <ConversionBlock testId="conversion-block-mid" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
